import { Component, OnInit, Renderer2, OnDestroy, AfterViewInit, ElementRef, ViewChild } from "@angular/core";
import { FormGroup, FormBuilder } from "@angular/forms";
import { Validators } from "@angular/forms";
import { AuthService } from "../../service/auth-service/auth.service";
import { Router } from "@angular/router";
import { Observable } from "rxjs";
import { sweetAlert } from "../../utils/swal";
import { takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { SocketService } from "src/app/service/socket-service/socket-service.service";
import { SharedDataService } from "src/app/service/shared-service/shared-data.service";
import { environment } from "src/environments/environment";
import { AssigTripsService } from "../assigned-trips/assigntrips-service/assigntrips-service";


@Component({
  selector: "app-sign-in",
  templateUrl: "./sign-in.component.html",
  styleUrls: ["./sign-in.component.css"],
})
export class SignInComponent implements OnInit, OnDestroy {
  success: boolean;
  passwordToggleFlag = true;
  signInForm: FormGroup;
  submitted = false;
  isAdmin = false;
  isCompany = true;
  isShowToggler = false;

  constructor(
    private renderer: Renderer2,
    private fb: FormBuilder,
    private assignTripService: AssigTripsService,
    private authService: AuthService,
    private sharedDataService: SharedDataService,
    private socket: SocketService,
    private router: Router,
    private renderere: Renderer2,
    private elementRef: ElementRef
  ) { }

  ngOnInit() {
    window.addEventListener("keyup", this.initializeTimer);
    this.signInForm = this.fb.group({
      email: ["", [Validators.required, Validators.email]],
      password: ["", [Validators.required, Validators.minLength(6), Validators.maxLength(16)]],
    });
  }

  randomInRange(min: number, max: number): number {
    return Math.random() * (max - min) + min;
  }

  initializeTimer = (e) => {
    if (
      e.altKey &&
      (e.key.toLowerCase() === "v" || e.key.toLowerCase() === "√")
    ) {
      this.isShowToggler = !this.isShowToggler;
      if (this.isShowToggler) {
        this.isAdmin = true;
        this.isCompany = false;
      } else {
        this.isCompany = true;
        this.isAdmin = false;
      }
    }
  };

  get form() {
    return this.signInForm.controls;
  }

  togglePasswordType() {
    this.passwordToggleFlag = !this.passwordToggleFlag;
  }

  onSignIn() {

    this.submitted = true;
    if (this.signInForm.invalid) {
      return;
    }

    let role;

    if (this.isAdmin) {
      role = 'admin';

    } else {
      if (this.isCompany) {
        role = 'company';
      } else {
        role = 'staff';
      }

    }



    this.authService
      .login(this.signInForm.value.email, this.signInForm.value.password, role)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data && data.success) {
          if (data.user && data.user.hasOwnProperty('isForceLogout') && data.user.isForceLogout) {
            return true;
          }
          this.authService.setToken(data.token);
          if (data.user && data.user.authToken) {
            this.authService.setAuthToken(data.user.authToken);
          }
          this.sharedDataService.saveUser(data.user);
          this.socket.connectSocket();
          this.router.navigateByUrl('/');
        } else {
          sweetAlert("Error", data.message, "warning", "OK");
        }
      });
  }

  addJsToElement(src: string): HTMLScriptElement {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = src;
    this.renderere.appendChild(document.body, script);
    return script;
  }

  changeAdminRole() {
    this.isAdmin = !this.isAdmin;
    this.isCompany = true;
  }

  ngOnDestroy(): void {
    window.removeEventListener("keyup", this.initializeTimer);
  }
}
